import { combineReducers } from "@reduxjs/toolkit";
import inputReducer from "Dashboard/scenes/Stock/secenes/Input/inputSlice";
import outputReducer from "Dashboard/scenes/Stock/secenes/Output/outputSlice";

const rootReducer = combineReducers({
  input: inputReducer,
  output: outputReducer,
});

export default rootReducer;
